//资产评估师pa
const majorTag = 'pa'
const settings = {
  //项目名称
  title: '资产评估师机考模拟系统',
  //机考辅导类型
  category: '资产评估师',
  //机考辅导ID
  majorID:6,//高级会计师7 资产评估师6
  //辅导名称
  majorTag:majorTag,
  //生产环境二级路径
  publicPath: '/qzSim/'+majorTag+'/',
  //生产环境构建文件目录
  outputDir: 'webApp',
  //静态资源放置目录
  assetsDir: 'static',
  //aes密钥
  aesKey: '823s4125660ijf;*',
  //iv密钥
  ivKey: 'qyu148#4(1p_1^4;',
  //请求接口地址
  baseApi: '/simPaperGw/moniexam',
  //请求重试delay
  retryDelay: 5000
}

module.exports = settings
